// extracted by mini-css-extract-plugin
module.exports = {"root":"WebshopSection_root__1rvx-","main":"WebshopSection_main__3znFb","header":"WebshopSection_header__bOR3w","filter":"WebshopSection_filter__3ciH-"};